import { DocumentSettingsSection } from "~/components/domain/settings/documents/DocumentSettingsSection";
import { ProductCodeAttributeMultiSelect } from "~/modules/products/ProductCodeAttributeSelect";
import type { DocumentAttributeWireCatalogEntry } from "~/shared/documents/schemas/document-attribute-wiring.schema";
import { Stack, Text } from "~/ui";

type DocumentAttributeWiringSectionProps = {
  title?: string;
  description?: string;
  catalog: readonly DocumentAttributeWireCatalogEntry[];
  wiring: Record<string, string[] | undefined>;
  onWireChange: (wireKey: string, attributeIds: string[]) => void;
  canEdit: boolean;
};

/** Self-serve ProductCodeAttribute wiring for document prefill fields. @see docs/OPT_IN_ORDER_DOCUMENTS.md */
export const DocumentAttributeWiringSection = ({
  title = "Attribute wiring",
  description = "Map one or more product attributes to each document prefill field. When multiple wired attributes have values, the create modal shows a picker.", // lint-guard-disable-line max-len -- settings copy
  catalog,
  wiring,
  onWireChange,
  canEdit,
}: DocumentAttributeWiringSectionProps) => (
  <DocumentSettingsSection title={title} description={description} spacing="xs">
    {catalog.length === 0 && (
      <Text size="sm" color="dimmed">
        No attribute wiring targets for this document.
      </Text>
    )}
    <Stack spacing="sm">
      {catalog.map(entry => (
        <ProductCodeAttributeMultiSelect
          key={entry.wireKey}
          label={entry.label}
          placeholder="Not wired"
          clearable
          searchable
          disabled={!canEdit}
          value={wiring[entry.wireKey] ?? []}
          onChange={value => onWireChange(entry.wireKey, value)}
        />
      ))}
    </Stack>
  </DocumentSettingsSection>
);
